module.exports = __webpack_public_path__ + "static/media/k12_site_contact_header.2b9429af.jpg";